/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section5_TitleInputs */

const en_privacy_section5_title = /** @type {(inputs: Privacy_Section5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressive Web App (PWA)`)
};

const ko_privacy_section5_title = /** @type {(inputs: Privacy_Section5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로그레시브 웹 앱 (PWA)`)
};

const ja_privacy_section5_title = /** @type {(inputs: Privacy_Section5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログレッシブウェブアプリ（PWA）`)
};

/**
* | output |
* | --- |
* | "Progressive Web App (PWA)" |
*
* @param {Privacy_Section5_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section5_title = /** @type {((inputs?: Privacy_Section5_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section5_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section5_title(inputs)
	if (locale === "ko") return ko_privacy_section5_title(inputs)
	return ja_privacy_section5_title(inputs)
});